import * as React from "react";

import type { ScrollableChatRef } from "./ScrollableChat";

/**
 * Pins the turn holding `pinnedTurnRef` to the top of the chat when a prompt is sent, and releases the pin when
 * `lastSentMessageId` clears. Keyed on the sent message, not the latest user message: loading a conversation must
 * not pin anything. The turn needs `min-h-full`, or a short answer leaves too little height to scroll it to the top.
 */
export const usePinnedTurn = (lastSentMessageId: string | null) => {
  const chatRef = React.useRef<ScrollableChatRef>(null);
  const pinnedTurnRef = React.useRef<HTMLDivElement>(null);
  const hasPinRef = React.useRef(false);

  React.useLayoutEffect(() => {
    if (lastSentMessageId && pinnedTurnRef.current) {
      chatRef.current?.pinToTop(pinnedTurnRef.current);
      hasPinRef.current = true;
    } else if (hasPinRef.current) {
      chatRef.current?.scrollToBottom();
      hasPinRef.current = false;
    }
  }, [lastSentMessageId]);

  return { chatRef, pinnedTurnRef };
};
